import api from '@/apis/dashboard/dashboardSurplusDeficitAPI.js';
import apisituation from '@/apis/dashboard/dashboardBudgetSituation.js';
import apiActivity from '@/apis/dashboard/dashboardResultActivityAPI.js';
import apiBudgetPlan from '@/apis/dashboard/dashboardBudgetPlanImplementationAPI.js';
import apiusingincomeandexpense from '@/apis/dashboard/dashboardUsingIncomeAndExpenseAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

export const useDashboardCombo = (comboboxDataRemote, comboboxLoadData) => {
  const { extendFilter } = usefilterActionCombo();
  const { proxy } = getCurrentInstance();

  // func call api lấy dữ liệu combo
  const onDashboardComboboxLoadData = (payload, row, column, custom) => {
    
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // func call api lấy dữ liệu combo
  const onDashboardComboboxLoadDataSituation = (payload, row, column, custom) => {
    comboboxLoadData(payload, apisituation, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // func call api lấy dữ liệu combo hoạt động
  const onDashboardComboboxActiveLoadData = (payload, row, column, custom) => {
    comboboxLoadData(payload, apiActivity, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };
  
  const onDashboardComboboxLoadDataBudgetPlan = (payload, row, column, custom) => {
    comboboxLoadData(payload, apiBudgetPlan, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // func call api lấy dữ liệu combo hoạt động chart6
  const onDashboardComboboxLoadDataActivity = (payload, row, column, custom) => {
    comboboxLoadData(payload, apiusingincomeandexpense, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  return {
    onDashboardComboboxLoadData,
    onDashboardComboboxLoadDataSituation,
    onDashboardComboboxActiveLoadData,
    onDashboardComboboxLoadDataBudgetPlan,
    onDashboardComboboxLoadDataActivity
  };
};
